import React, { createContext, useContext, useState } from 'react';

interface StartOverModalContextType {
  isStartOverModalOpen: boolean;
  openStartOverModal: () => void;
  closeStartOverModal: () => void;
}

const StartOverModalContext = createContext<StartOverModalContextType | undefined>(undefined);

interface StartOverModalProviderProps {
  children: React.ReactNode;
}

export const StartOverModalProvider: React.FC<StartOverModalProviderProps> = ({ children }) => {
  const [isStartOverModalOpen, setIsStartOverModalOpen] = useState(false);

  const openStartOverModal = () => {
    setIsStartOverModalOpen(true);
  };

  const closeStartOverModal = () => {
    setIsStartOverModalOpen(false);
  };

  return (
    <StartOverModalContext.Provider value={{ isStartOverModalOpen, openStartOverModal, closeStartOverModal }}>
      {children}
    </StartOverModalContext.Provider>
  );
};

export const useStartOverModal = (): StartOverModalContextType => {
  const context = useContext(StartOverModalContext);
  if (context === undefined) {
    throw new Error('useStartOverModal must be used within a StartOverModalProvider');
  }
  return context;
};
